module.exports = __webpack_public_path__ + "static/media/medium.28f2c248.svg";